<template>
  <div>
    <table class="table table-completion-report">
      <thead>
        <tr>
          <th class="text-right field-label">
            Field
          </th>
          <th class="text-c">
            Filled in?
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="field in report.fields" :key="field.name">
          <td class="text-right field-label">
            {{ field.label }}
            <span v-if="field.help" class="text-muted text-xs margin-top-5">
              ({{ field.help }})
            </span>
          </td>
          <td class="text-c">
            <div class="checkbox">
              <i v-if="field.done === true" class="ion ion-checkmark" />
              <span v-if="!field.done && field.innerProgress">
                {{ field.innerProgress }}%
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { startupProfileFieldLabel } from 'modules/startup-profile/filters'
import { getReport } from 'services/startup-report'

export default {
  filters: { startupProfileFieldLabel },
  props: ['startup'],
  computed: {
    report() {
      return getReport(this.startup)
    },
  },
}
</script>

<style lang="scss">
.table-completion-report {
  thead tr th.field-label,
  tbody tr td.field-label {
    padding-right: 20px;
  }
}
</style>
